<template>
  <img
    v-if="getCouponImage && !isLoadFailed"
    :class="isBanner ? 'coupon_image_banner' : 'coupon_image_thumbnail'"
    :src="getImageSrc"
    :alt="alt"
    :loading="isBanner ? undefined : 'lazy'"
    decoding="async"
    :style="isBanner ? { aspectRatio: getAspectRatio } : undefined"
    @error="isLoadFailed = true"
  />
</template>

<script>
import { getCouponImage } from "@/utils/couponTemplate.utils";

export default {
  name: "CouponImage",
  props: {
    image: { type: Object, default: null },
    variant: {
      type: String,
      default: "thumbnail",
      validator: (value) => ["thumbnail", "banner"].includes(value),
    },
    alt: { type: String, default: "" },
  },
  data() {
    return { isLoadFailed: false };
  },
  computed: {
    getCouponImage() {
      return getCouponImage(this.image);
    },
    isBanner() {
      return this.variant === "banner";
    },
    getImageSrc() {
      return this.isBanner ? this.getCouponImage?.imageUrl : this.getCouponImage?.previewUrl;
    },
    getAspectRatio() {
      const image = this.getCouponImage;
      if (!image?.width || !image?.height) return 1;
      return Math.min(2, Math.max(0.75, image.width / image.height));
    },
  },
  watch: {
    getCouponImage(image, previousImage) {
      if (
        image?.imageUrl !== previousImage?.imageUrl ||
        image?.previewUrl !== previousImage?.previewUrl
      ) this.isLoadFailed = false;
    },
  },
};
</script>

<style scoped>
.coupon_image_thumbnail {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  align-self: center;
  border-radius: 6px;
  object-fit: cover;
  background: #f5f5f5;
}
.coupon_image_banner {
  display: block;
  width: 100%;
  max-width: 480px;
  margin: 0 auto 16px;
  border-radius: 6px;
  object-fit: contain;
  background: #f5f5f5;
}
</style>
